<template>
  <td
    :colspan="colspan ? colspan : 20"
    class="TicketsDetailsTransactionsToExport"
  >
    <table
      v-for="placeData in placeDetails"
      :key="'transaction-details-place-to-export-' + transactionId + '-' + placeData.sitio"
      style="width: 100%"
    >
      <thead>
        <tr>
          <td>
            <h4>{{ placeData.shortname }}</h4>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td :colspan="colspan ? colspan : 20">
            <table
              border="1"
              bordercolor="#272727"
              style="border-collapse: collapse !important; width: 100%"
            >
              <thead>
                <tr>
                  <td align="center">
                    <strong>Tipo de boleto</strong>
                  </td>
                  <td :style="`width:${detailed ? 30 : 40}%;`">
                    <strong>Nombre del Boleto</strong>
                  </td>
                  <td align="center">
                    <strong>Cantidad</strong>
                  </td>
                  <td
                    v-if="detailed"
                    align="center"
                  >
                    <strong>Impreso(s)</strong>
                  </td>
                  <td
                    v-if="detailed"
                    align="Disponibles(s)"
                  >
                    <strong>Disponibles(s)</strong>
                  </td>
                  <td align="right">
                    <strong>Precio Unitario</strong>
                  </td>
                  <td align="right">
                    <strong>Costo</strong>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="ticketData in placeData.transaccion"
                  :key="`transaction-details-place-${transactionId}-${placeData.sitio}-${ticketData.id_ticket}-${ticketData.persontype}-${ticketData.npool}`"
                >
                  <td align="center">
                    {{ ticketData.id_ticket }}
                  </td>
                  <td>
                    {{ ticketData.nombre }}
                    <span v-if="ticketData.alias">({{ ticketData.alias }})<strong>{{ ticketData.fecha }}</strong></span>
                  </td>
                  <td align="center">
                    {{ ticketData.cantidad }}
                  </td>
                  <td
                    v-if="detailed"
                    align="center"
                  >
                    {{ $formatNum(ticketData.usado) }}
                  </td>
                  <td
                    v-if="detailed"
                    align="center"
                  >
                    {{ $formatNum(ticketData.n_usado) }}
                  </td>
                  <td align="right">
                    ${{ $formatPrice(ticketData.costo) }}
                  </td>
                  <td align="right">
                    ${{ $formatPrice(ticketData.total) }}
                  </td>
                </tr>
                <tr v-if="placeData.total">
                  <td
                    :colspan="detailed ? 6 : 4"
                    align="right"
                  >
                    <strong>Total: </strong>
                  </td>
                  <td
                    align="right"
                    class="place-total pt-0"
                  >
                    <strong>${{ $formatPrice(placeData.total) }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr />
      </tbody>
    </table>
  </td>
</template>

<script>
export default {
  name: 'TicketsDetailsTransactionsToExport',
  props: ['colspan', 'placeDetails', 'transactionId', 'detailed']
}
</script>

<style scoped>
  .place-title {
    background: white;
    padding: 15px 0px 0px 5px !important;
    font-weight: bold;
  }
</style>
